import {createAction, props} from '@ngrx/store';
import {PaperChatFilterType, PaperChatWebsocketDTO} from '../dto/paper-chat';


export const setChatFilterType = createAction(
  '[PaperChat] Set Chat Filter Type',
  props<{ filterType: PaperChatFilterType, projectId: number }>()
);

export const connectToProject = createAction(
  '[PaperChat] Connect to Project',
  props<{ projectId: number, summaryId?: number, paperId?: number}>()
);

export const connectSuccess = createAction(
  '[PaperChat] Connect Success',
  props<{ projectId: number }>()
);

export const connectFailure = createAction(
  '[PaperChat] Connect Failure',
  props<{ projectId: number; error: any }>()
);

export const sendMessage = createAction(
  '[PaperChat] Send Message',
  props<{ projectId: number; message: string }>()
);

export const receiveMessage = createAction(
  '[PaperChat] Receive Message',
  props<{ message: PaperChatWebsocketDTO }>()
);

export const disconnect = createAction(
  '[PaperChat] Disconnect from Project',
  props<{ projectId: number }>()
);

export const disconnectSuccess = createAction(
  '[PaperChat] Disconnect Success',
  props<{ projectId: number }>()
);

export const disconnectFailure = createAction(
  '[PaperChat] Disconnect Failure',
  props<{ projectId: number; error: any }>()
);
